import React, { useEffect, useState } from 'react'
import ButtonSubmit from "../components/ButtonSubmit";
import InputUser from "../components/InputUser";
import "./../components/Navbar/NavBar.css";
import NavBar  from '../components/Navbar/NavBar';
import classNames from 'classnames';
import FooterLoginRegister from '../components/FooterLoginRegister';
import { useNavigate, NavLink } from 'react-router-dom';
import axios from 'axios';

import { showMessage } from '../components/Functions';
export default function LoginPage({setIsToken}) {
  let navigate = useNavigate();
  const [typeInputPass,setTypeInputPass]= useState("password")
  const [email,setEmail] = useState("mohanned.banna03@gmail.com")
  const [password,setPassword] = useState("M123456789")
  const baseUrl = 'https://prohop-express.herokuapp.com/api/users/login'
  // console.log(username)
  // console.log(password)
    const parms = {
      "email": email,
      "password": password
  }
    
    const loginBtnClick = (e) =>{
      e.preventDefault()
      axios.post(baseUrl,parms)
      .then((response) =>{
        if(response.data.token){
          setIsToken(true)
          navigate("/home");
          localStorage.setItem("token",true)
          showMessage("Logged in successfully","#4cbc6a")
        }
      }).catch((error) =>{
        showMessage(error.response.data.message,"#ff3333")
      
      })
    } 
     
  return (
    <div className='flex flex-col gap-16 sm:gap-12 h-full bgAuth'>
      <NavBar />
      <form className={classNames("flex flex-col gap-5 container mx-auto my-32 w-9/12 sm:w-8/12 md:w-7/12 lg:w-6/12 xl:w-5/12 grow-[2] ")}>
        <InputUser name ="User Name" type="email" icon="fa fa-user text-white mr-3 " value= {email} setValue={setEmail}/>
        <InputUser name ="Password" type={typeInputPass}  icon="fa-solid fa-unlock text-white mr-3" value={password} setValue={setPassword} eyeIcon setTypeInput={setTypeInputPass} />
        <ButtonSubmit name="GET STARTED" BtnClick={loginBtnClick} />
        <span className='block text-center'>Don't have an account? <NavLink to="/Register" className="text-[#4e3587]">Sign up</NavLink>  </span>
      </form>
          <FooterLoginRegister classname="flex sm:ml-4 "/>
    </div>
  )
}
